import PropTypes from "prop-types";
import React from "react";
import classNames from 'classnames';
import registeredComponent from "../../utils/registeredComponent";
import { Link } from "react-router";
import duckify, { singleDuck } from "../../utils/duckify";
import { customers as customersDuck } from "../../ducks";

/**
 * AdmissionsReportNav is a navigation component that allows switching between admissions reports.
 */
const AdmissionsReportNav = ({ customer, view }) => {
  const showLeads = customer && customer.modules.includes('lead_management');
  const showCross = customer && customer.modules.includes('shared_portal');
  if (!showCross && !showLeads) {
    return <React.Fragment />;
  }
  return (
    <ul className={"nav nav-pills flat-pill page-menu d-inline-flex"}>
      {showLeads && (
        <li className={classNames("first", { active: view === "leads" })}>
          <Link href={classNames("/reporting/lead_source_report")}>Leads</Link>
        </li>
      )}
      <li className={classNames({ active: view === "admissions" })}>
        <Link href={"/reporting/admissions_funnel"}>Admissions</Link>
      </li>
      {showCross && (
        <li className={classNames({ active: view === 'cross_applicants' })}>
          <Link href='/reporting/cross_applicants_report'>Explore Applicants</Link>
        </li>
      )}
    </ul>
  );
};

AdmissionsReportNav.propTypes = {
  view: PropTypes.oneOf(['leads', 'admissions', 'cross_applicants'])
};

const mapDucksToProps = () => ({
  customer: singleDuck(customersDuck, 'current')
});

export default registeredComponent("AdmissionsReportNav")(duckify(mapDucksToProps)(AdmissionsReportNav));
